export enum BoxType {
    Inbox = 'inbox',
    Outbox = 'outbox',
    Forums = 'forums',
    Archive = 'archive'
}
